<nav *ngIf="!isLoggedIn" class="navbar navbar-dark bg-dark navbar-expand-lg responsive-breakpoints">
  <div class="container-fluid pe-2">
    <span class="navbar-brand">
      <a routerLink="/">
        <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-text.webp" style="height: 1.5rem; position: relative; top: -0.20rem;" class="me-3">
      </a>
    </span>
    <button #menu class="navbar-toggler my-toggle me-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div #offcanvas class="offcanvas offcanvas-end" style="width: 20rem;" tabindex="-1" id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-header mb-0 pb-0 statusbar-padding">
        <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-text.webp" style="height: 1.5rem; border: none; margin: 0px; padding: 0px;">
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1">
          <li *ngIf="apiURLSet" class="nav-item">
            <a class="nav-link" data-bs-dismiss="offcanvas" routerLink="/" [queryParams]="{ new: true }" [class.active]="isActive()" i18n>New order</a>
          </li>
          <li *ngIf="apiURLSet" class="nav-item" style="height: 0.5rem;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-dismiss="offcanvas" routerLink="/about" routerLinkActive="active" i18n>What is Nuuduu?</a>
          </li>
          <li *ngIf="platform == 'web'" class="nav-item">
            <a class="nav-link" [href]="'/partners/' + locale + '/find-work'" i18n>Start working</a>
          </li>
          <li *ngIf="apiURLSet" class="nav-item" style="height: 0.5rem;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </li>
          <li *ngIf="apiURLSet" class="nav-item">
            <a class="nav-link" data-bs-dismiss="offcanvas" routerLink="/signin" routerLinkActive="active" i18n>Sign in / Sign up</a>
          </li>
          <li class="nav-item">
            <a (click)="languageSelector()" class="nav-link cursor-pointer" data-bs-dismiss="offcanvas">
              <ng-container *ngIf="organization">
                <img [alt]="organization | translateField: 'country'" [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'" style="height: 1rem; border: none; position: relative; top: -1px;" class="me-1">
                {{ locale | i18nSelect: locales }}
              </ng-container>
              <ng-container *ngIf="!organization">
                <fa-icon [icon]="fa.faGlobe" style="color:#fff;"></fa-icon>&nbsp;
                <ng-container i18n>Location</ng-container>
              </ng-container>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>

<nav *ngIf="isLoggedIn" class="navbar navbar-dark bg-dark navbar-expand-lg responsive-breakpoints">
  <div class="container-fluid pe-2">
    <span class="navbar-brand">
      <a routerLink="/">
        <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-text.webp" style="height: 1.5rem; position: relative; top: -0.20rem;" class="me-3">
      </a>
    </span>
    <button #menu class="navbar-toggler my-toggle me-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
      <span class="navbar-toggler-icon"></span>
      <span *ngIf="messageCount" class="position-absolute translate-middle badge rounded-pill bg-danger"
        style="top: 18px; right: -7px;">
        {{ messageCount }}
      </span>
    </button>
    <div #offcanvas class="offcanvas offcanvas-end" style="width: 20rem;" tabindex="-1" id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-header mb-0 pb-0 statusbar-padding">
        <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-text.webp" style="height: 1.5rem; border: none; margin: 0px; padding: 0px;">
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1">
          <li class="nav-item">
            <a class="nav-link" data-bs-dismiss="offcanvas" routerLink="/" [queryParams]="{ new: true }" [class.active]="isActive()" i18n>New order</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/shifts" data-bs-dismiss="offcanvas" routerLinkActive="active" i18n>Orders</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-dismiss="offcanvas" routerLink="/chat">
              <span i18n>Chat</span>
              <span *ngIf="messageCount" class="float-end badge rounded-pill bg-danger"
                style="position: relative; top: 1px; left: 3px;">
                {{ messageCount }}
              </span>
            </a>
          </li>
          <li *ngIf="currentUser.show_reports" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true"
              aria-expanded="false" i18n>Reports</a>
            <div class="dropdown-menu">
              <a routerLink="/reports/location" class="dropdown-item cursor-pointer" data-bs-dismiss="offcanvas"
                data-bs-target=".navbar-collapse.show" i18n>Costs by location</a>
            </div>
          </li>
          <li class="nav-item" style="height: 0.5rem;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/settings" data-bs-dismiss="offcanvas" routerLinkActive="active"
              [ngClass]="{ 'text-danger': currentUser.balance < 0 }">
              <fa-icon [icon]="fa.faCog" style="position: relative; top: 1px;"></fa-icon>
              <span class="d-lg-none ms-2" i18n>Settings</span>
              <span *ngIf="currentUser.balance < 0" class="float-end badge rounded-pill bg-danger d-lg-none"
                style="position: relative; top: 4px;">
                {{ currentUser.balance | currency: organization.currency }}
              </span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="signOut()" data-bs-dismiss="offcanvas">
              <fa-icon [icon]="fa.faSignOutAlt"></fa-icon>
              <span class="d-lg-none ms-1" i18n>Sign out</span>
            </a>
          </li>
          <li class="nav-item">
            <a (click)="languageSelector()" class="nav-link cursor-pointer" data-bs-dismiss="offcanvas">
              <ng-container *ngIf="organization">
                <img [alt]="organization | translateField: 'country'" [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'" style="height: 1rem; border: none; position: relative; top: -1px;" class="me-1">
                {{ locale | i18nSelect: locales }}
              </ng-container>
              <ng-container *ngIf="!organization">
                <fa-icon [icon]="fa.faGlobe" style="color:#fff;"></fa-icon>&nbsp;
                <ng-container i18n>Location</ng-container>
              </ng-container>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>

<div class="container-fluid">
  <router-outlet></router-outlet>
</div>